import { PoweredBy } from './PoweredBy';

export { PoweredBy };
export default PoweredBy;
